import { OptionSubCategory } from 'owa-options-core';
import WeatherOption from 'owa-weather-option/lib/WeatherOption';
import loadCalendarMailboxConfiguration from './loadCalendarMailboxConfiguration';

let weatherSubCategory: OptionSubCategory = {
    key: 'weather',
    titleStringKey: 'optionSubcategory_weather',
    options: [WeatherOption],
    onSelected: loadCalendarMailboxConfiguration,
};

export default weatherSubCategory;
